var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.731 386.603C216.674 392.55 223.731 397.268 231.499 400.487C239.266 403.706 247.592 405.362 256 405.362C264.408 405.362 272.734 403.706 280.501 400.487C288.269 397.268 295.326 392.55 301.269 386.603L369.771 318.101C373.443 314.039 375.414 308.72 375.273 303.246C375.132 297.772 372.892 292.561 369.016 288.693C365.139 284.825 359.924 282.595 354.449 282.466C348.974 282.337 343.66 284.319 339.605 288L277.184 350.443L277.333 21.3333C277.333 15.6754 275.086 10.2492 271.085 6.24839C267.084 2.24761 261.658 0 256 0V0C250.342 0 244.916 2.24761 240.915 6.24839C236.914 10.2492 234.667 15.6754 234.667 21.3333L234.475 350.037L172.395 288C168.392 284 162.964 281.754 157.304 281.756C151.645 281.758 146.219 284.008 142.219 288.011C138.219 292.014 135.972 297.442 135.974 303.101C135.976 308.76 138.226 314.187 142.229 318.187L210.731 386.603Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.667 341.333C485.009 341.333 479.582 343.581 475.582 347.582C471.581 351.582 469.333 357.009 469.333 362.667V448C469.333 453.658 467.086 459.084 463.085 463.085C459.084 467.086 453.658 469.333 448 469.333H64C58.342 469.333 52.9158 467.086 48.9151 463.085C44.9143 459.084 42.6667 453.658 42.6667 448V362.667C42.6667 357.009 40.4191 351.582 36.4183 347.582C32.4175 343.581 26.9913 341.333 21.3333 341.333V341.333C15.6754 341.333 10.2492 343.581 6.24839 347.582C2.24761 351.582 0 357.009 0 362.667L0 448C0 464.974 6.74284 481.253 18.7452 493.255C30.7475 505.257 47.0261 512 64 512H448C464.974 512 481.253 505.257 493.255 493.255C505.257 481.253 512 464.974 512 448V362.667C512 357.009 509.752 351.582 505.752 347.582C501.751 343.581 496.325 341.333 490.667 341.333Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadV2);
export default __webpack_public_path__ + "static/media/downloadV2.91c19b4cd3d3718a2f434b8419178a60.svg";
export { ForwardRef as ReactComponent };